import type { ThemeConfig } from 'antd';

export const sfTheme: ThemeConfig = {
  token: {
    colorPrimary: '#6E247F',
    colorInfo: '#6470FF',
    colorSuccess: '#34D354',
    colorWarning: '#F5A623',
    colorError: '#E74C3C',
    fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    borderRadius: 8,
    fontSize: 14,
  },
  components: {
    Layout: {
      siderBg: '#1B1F23',
      headerBg: '#FFFFFF',
    },
    Menu: {
      darkItemBg: '#1B1F23',
      darkItemColor: '#FBFBFB',
      darkItemSelectedBg: '#6E247F',
    },
  },
};
